
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.113 10.1a20.431 20.431 0 01-1.919-.32c-1.49-.324-2.665-.802-3.526-1.435v1.921c0 .52.373 1.003 1.118 1.447.745.445 1.757.797 3.038 1.057.28.057.566.108.857.152a6.65 6.65 0 01.432-2.821zm.727-1.377c-.7-.065-1.372-.162-2.016-.293-1.28-.26-2.293-.612-3.038-1.057-.745-.444-1.118-.927-1.118-1.447v-.533c0-.52.373-1.002 1.118-1.446.745-.445 1.757-.795 3.038-1.051C7.104 2.632 8.497 2.5 10 2.5c1.505 0 2.897.13 4.178.39 1.28.26 2.293.612 3.038 1.057.745.444 1.118.926 1.118 1.446v.533c0 .468-.302.906-.906 1.313a6.638 6.638 0 00-4.094-1.406 6.66 6.66 0 00-5.495 2.89zm-.891 5.698a6.67 6.67 0 001.949 3.055 19.916 19.916 0 01-3.074-.366c-1.28-.26-2.293-.612-3.038-1.057-.745-.444-1.118-.927-1.118-1.446v-1.922c.86.633 2.036 1.112 3.526 1.436.569.123 1.154.223 1.755.3z","fill":"#454C52"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.333 6.668a5.833 5.833 0 100 11.667 5.833 5.833 0 000-11.667z","fill":"#009BDE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.444 16l-3.733-.524v-2.742h3.734l-.001 3.267zm-4.199-3.73H9.45l-.004-2.276 2.8-.38v2.655zm-.002 3.146l-2.798-.383v-2.299h2.798v2.682zm.467-5.873L16.445 9v3.266H12.71V9.543z","fill":"#fff"}})])
          )
        }
      }
    